import * as React from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, colors, shapes } from '@cimpress/react-components';
import { IconDeliveryParachute, IconUploadBottom, IconPictureFlowerAlt } from '@cimpress-technology/react-streamline-icons';
import { useDoubleTTranslation } from '../hooks/i18n';
const { slate, alloy, ocean } = colors;
const dropZoneContainer = {
    border: `2px dashed ${alloy}`,
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '160px',
    width: '100%'
};
const orStyle = {
    color: slate,
    flexShrink: 0,
    margin: '0 15px',
    textTransform: 'uppercase'
};
const uploadText = Object.assign(Object.assign({}, orStyle), { fontWeight: 'bold', fontSize: '1.5em', textTransform: 'none' });
const uploadTextContainer = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: ocean.base
};
const marginLeft = { marginLeft: '15px' };
const marginRight = { marginRight: '15px' };
const marginBottom = { marginBottom: '5px' };
const marginBoth = Object.assign(Object.assign({}, marginLeft), marginRight);
const uploadTextMarginLeft = Object.assign(Object.assign({}, uploadText), marginLeft);
export var UploadDropZoneStatus;
(function (UploadDropZoneStatus) {
    UploadDropZoneStatus[UploadDropZoneStatus["ReadyToUpload"] = 0] = "ReadyToUpload";
    UploadDropZoneStatus[UploadDropZoneStatus["Uploading"] = 1] = "Uploading";
    UploadDropZoneStatus[UploadDropZoneStatus["Processing"] = 2] = "Processing";
    UploadDropZoneStatus[UploadDropZoneStatus["Processed"] = 3] = "Processed";
})(UploadDropZoneStatus || (UploadDropZoneStatus = {}));
export const UploadDropZone = props => {
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: props.onDrop,
        onFileDialogCancel: props.onFileDialogCancel,
        multiple: false,
        disabled: props.status !== UploadDropZoneStatus.ReadyToUpload
    });
    const { tt } = useDoubleTTranslation(props.language);
    const handleDelete = () => {
        if (props.onDelete) {
            props.onDelete();
        }
    };
    let statusContent = null;
    switch (props.status) {
        case UploadDropZoneStatus.ReadyToUpload:
            statusContent = (React.createElement(React.Fragment, null,
                React.createElement(IconUploadBottom, { color: ocean.base, size: "3x", weight: "light" }),
                React.createElement("div", { style: marginLeft }, tt('uploadDropZone.dragAndDrop')),
                React.createElement("div", { style: orStyle },
                    "\u2014 ",
                    tt('uploadDropZone.or'),
                    " \u2014"),
                React.createElement("label", { className: "btn btn-default" }, tt('uploadDropZone.chooseFile'))));
            break;
        case UploadDropZoneStatus.Uploading:
            statusContent = (React.createElement(React.Fragment, null,
                React.createElement(shapes.Spinner, { size: 'medium' }),
                React.createElement("div", { style: marginBoth }, tt('uploadDropZone.uploading'))));
            break;
        case UploadDropZoneStatus.Processing:
            statusContent = (React.createElement(React.Fragment, null,
                React.createElement(shapes.Spinner, { size: 'medium' }),
                React.createElement("div", { style: marginBoth }, tt('uploadDropZone.uploading'))));
            break;
        default:
            statusContent = (React.createElement(React.Fragment, null,
                React.createElement(IconPictureFlowerAlt, { color: ocean.base, size: "3x", weight: "light" }),
                React.createElement("div", { style: Object.assign(Object.assign({}, marginLeft), { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }) },
                    React.createElement("div", { style: marginBottom }, props.fileName),
                    React.createElement(Button, { onClick: handleDelete }, tt('uploadDropZone.removeFile')))));
            break;
    }
    return (React.createElement("div", Object.assign({}, getRootProps(), { className: "well", style: dropZoneContainer }),
        React.createElement("input", Object.assign({}, getInputProps())),
        isDragActive ? (React.createElement(React.Fragment, null,
            React.createElement(IconDeliveryParachute, { color: slate, size: "3x", weight: "light" }),
            React.createElement("div", { style: uploadTextMarginLeft }, tt('uploadDropZone.dropFilesHere')))) : (React.createElement("div", { style: uploadTextContainer }, statusContent))));
};
//# sourceMappingURL=UploadDropZone.js.map